/* eslint-disable no-console */

// Stub for React 18 DefaultProps errors
const originalConsoleError = window.console.error;
window.console.error = (...args) => {
  if (
    args[0] &&
    typeof args[0] === 'string' &&
    args[0].includes('Support for defaultProps will be removed from function components in a future major release')
  ) {
    console.warn(...args);
    return;
  }
  originalConsoleError(...args);
};
